import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';

    angular.module('depositorconfirm').controller('DepositorConfirmCtrl', DepositorConfirmCtrl);

    DepositorConfirmCtrl.$inject = [
        '$scope',
        '$state',
        '$uibModal',
        '$translate',
        '$cookies',
        'uiGridConstants',
        'API_CONFIG',
        'XSRF_TOKEN',
        'AuthSvc',
        'DepositorFilter',
        'DepositorService',
        'EnvelopeService',
        'DepositorConfirm',
        'toastr',
    ];

    /* @ngInject */
    function DepositorConfirmCtrl(
        $scope,
        $state,
        $uibModal,
        $translate,
        $cookies,
        uiGridConstants,
        API_CONFIG,
        XSRF_TOKEN,
        AuthSvc,
        DepositorFilter,
        DepositorService,
        EnvelopeService,
        DepositorConfirm,
        toastr
    ) {
        var vm = this;

        // ----------------------------
        // Data API
        // ----------------------------
        vm.getTableHeight = getTableHeight;
        vm.canExportGridCsv = canExportGridCsv;
        vm.getSelectedDepositorIds = getSelectedDepositorIds;
        vm.resumeEnvelopes = resumeEnvelopes;
        vm.rejectEnvelopes = rejectEnvelopes;

        vm.criteriaStringify = JSON.stringify(vm.searchData);
        const csrf = $cookies.get(XSRF_TOKEN);
        vm.exportCsvUrl = API_CONFIG.url + '/v1/depositor/csv-export?_csrf=' + csrf;
        vm.selectedItems = 'ok';

        // Recherche
        vm.searchData = new DepositorFilter();
        vm.search = search;
        vm.clearForm = clearForm;

        var columnFieldMap = [
            { field: 'email', property: 'email' },
            { field: 'name', property: 'name' },
            { field: 'antispamDate', property: 'antispamDate' },
            { field: 'envelopeCount', property: 'envelopeCount' },
            { field: 'spammer', property: 'status' },
        ];

        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="depositor_details({depositorId : row.entity.depositorId, tabName : \'confirm\'})"><div class="ui-grid-cell-contents ui-grid-cursor-pointer">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        // Liste
        vm.gridOptions = {
            columnDefs: [
                {
                    name: 'email',
                    displayName: 'Email',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    sort: {
                        direction: uiGridConstants.asc,
                        priority: 0,
                    },
                },
                {
                    name: 'name',
                    displayName: 'Raison sociale',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: 'translate',
                },
                {
                    name: 'antispamDate',
                    displayName: 'Notification 1er envoi',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    cellFilter: "date:'short'",
                },
                {
                    name: 'envelopeCount',
                    displayName: 'NB plis',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                    type: 'number',
                    cellClass: 'text-right',
                },
                {
                    name: 'getSpammerLabel()',
                    displayName: 'SPAM',
                    cellTemplate: defaultCellTemplate,
                    headerCellFilter: 'translate',
                },
            ],
            useExternalPagination: true,
            useExternalSorting: true,
            enableSorting: true,
            enableGridMenu: false,
            enableRowSelection: true,
            enableSelectAll: true,
            selectionRowHeaderWidth: 30,
            exporterMenuCsv: false,
            enableColumnMenus: false,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            enableVerticalScrollbar: uiGridConstants.scrollbars.NEVER,
            exporterHeaderFilter: $translate.instant,
            gridMenuTitleFilter: $translate,
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
                vm.gridApi.core.on.sortChanged($scope, sortChanged);
                vm.gridApi.pagination.on.paginationChanged($scope, paginationChanged);
            },
        };

        activate();

        // //////////////
        function activate() {
            //initialiser le filtre de recherche pour l'export
            if (vm.searchData.pageCriteria.sorts) {
                for (var i = 0; i < vm.gridOptions.columnDefs.length; i++) {
                    if (
                        vm.gridOptions.columnDefs[i].name ===
                        convertSortInverseName(vm.searchData.pageCriteria.sorts[0])
                    ) {
                        vm.gridOptions.columnDefs[i].sort = {
                            direction: angular.lowercase(vm.searchData.pageCriteria.sorts[0].direction),
                            priority: 0,
                        };
                        break;
                    }
                }
            }
            search();
        }

        function search() {
            vm.searchData.confirmationOnly = true;
            vm.criteriaStringify = JSON.stringify(vm.searchData);
            vm.depositorConfirmPromise = DepositorService.search(vm.searchData).$promise;
            vm.depositorConfirmPromise.then(function (result) {
                if (result.content) {
                    vm.gridOptions.data = _.map(result.content, function (depositorConfirmData) {
                        return new DepositorConfirm(depositorConfirmData);
                    });
                } else {
                    vm.gridOptions.data = [];
                }
            });
        }

        function clearForm() {
            // Reset data
            vm.searchData = new DepositorFilter();
            // Recherche
            vm.search();
            // Reset form
            vm.form.$setPristine();
        }

        function sortChanged(grid, sortColumns) {
            sortColumns = _.map(sortColumns, convertSort);
            if (sortColumns && sortColumns.length > 0) {
                vm.searchData.setSort(sortColumns);
            } else {
                vm.searchData.resetSort();
            }
            vm.search();
            vm.criteriaStringify = JSON.stringify(vm.searchData);
            vm.gridApi.selection.clearSelectedRows();
        }

        function convertSort(col) {
            var columnField = _.find(columnFieldMap, { field: col.field });
            if (col && col.sort) {
                return {
                    direction: angular.uppercase(col.sort.direction),
                    property: columnField ? columnField.property : col.field,
                    priority: col.sort.priority,
                };
            }
            return {};
        }

        function convertSortInverseName(col) {
            var columnField = _.find(columnFieldMap, { property: col.property });
            return columnField ? columnField.field : col.property;
        }

        function paginationChanged(page, size) {
            vm.searchData.setPageSize(size);
            vm.searchData.setPage(page - 1);
            $scope.searchDepositors();
        }

        // Indique si l'export CSV de la grille peut être réalisé
        function canExportGridCsv() {
            if (!(vm.gridApi === undefined || vm.gridApi.selection === undefined)) {
                return vm.gridApi.selection.getSelectedRows().length > 0;
            }
            return false;
        }

        function getTableHeight() {
            var rowHeight = 30;
            return {
                height: vm.gridApi.core.getVisibleRows(vm.gridApi.grid).length * rowHeight + 81 + 'px',
            };
        }

        function getSelectedDepositorIdsAsList() {
            var ids = [];
            if (vm.gridApi && vm.gridApi.selection) {
                var selectedRows = vm.gridApi.selection.getSelectedRows();
                ids = _.map(selectedRows, function (row) {
                    return row.depositorId;
                });
            }
            return ids;
        }

        function getSelectedDepositorIds() {
            var ids = [];
            if (vm.gridApi && vm.gridApi.selection) {
                var selectedRows = vm.gridApi.selection.getSelectedRows();
                for (var i = 0; i < selectedRows.length; i++) {
                    ids += selectedRows[i].depositorId + ',';
                }
            }
            return ids;
        }

        function resumeEnvelopes() {
            var depositorIds = getSelectedDepositorIdsAsList();
            if (depositorIds && depositorIds.length > 0) {
                var envelopeIds = EnvelopeService.findWaitingConfirmByDepositors({ ids: depositorIds }).$promise.then(
                    function (envelopes) {
                        return envelopes;
                    }
                );
                openResumeModal(envelopeIds);
            }
        }

        function rejectEnvelopes() {
            var depositorIds = getSelectedDepositorIdsAsList();
            if (depositorIds && depositorIds.length > 0) {
                var envelopeIds = EnvelopeService.findWaitingConfirmByDepositors({ ids: depositorIds }).$promise.then(
                    function (envelopes) {
                        return envelopes;
                    }
                );
                openRejectModal(envelopeIds);
            }
        }

        /** Popup de reprise de plis.*/
        function openResumeModal(envelopeIds) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: require('./process-modal.html'),
                controller: 'ProcessModalCtrl as vm',
                resolve: {
                    data: function () {
                        return {
                            title: $translate.instant('process.resumption.modal.choose.header'),
                            depositorsMsg: $translate.instant('process.resumption.modal.depositors.text'),
                            envelopesMsg: $translate.instant('process.resumption.modal.envelopes.text'),
                            motifMsg: $translate.instant('process.resumption.modal.choose.body.motif'),
                            selectedDepositors: vm.gridApi.selection.getSelectedRows(),
                            selectedEnvelopes: envelopeIds,
                        };
                    },
                    selectedDepositors: function () {
                        return vm.gridApi.selection.getSelectedRows();
                    },
                    selectedEnvelopes: function () {
                        return envelopeIds;
                    },
                },
            });
            modalInstance.result.then(
                function (params) {
                    EnvelopeService.resumptionFirstShipment({
                        envelopeIds: params.envelopeIds,
                        motif: params.motif,
                    }).$promise.then(
                        function () {
                            search();
                        },
                        function (error) {
                            toastr.error('Echec de reprise', error);
                        }
                    );
                },
                function () {}
            );
        }

        /** Popup de rejet de plis.*/
        function openRejectModal(envelopeIds) {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: require('./process-modal.html'),
                controller: 'ProcessModalCtrl as vm',
                resolve: {
                    data: function () {
                        return {
                            title: $translate.instant('process.reject.modal.choose.header'),
                            depositorsMsg: $translate.instant('process.reject.modal.depositors.text'),
                            envelopesMsg: $translate.instant('process.reject.modal.envelopes.text'),
                            motifMsg: $translate.instant('process.reject.modal.choose.body.motif'),
                            selectedDepositors: vm.gridApi.selection.getSelectedRows(),
                            selectedEnvelopes: envelopeIds,
                        };
                    },
                    selectedDepositors: function () {
                        return vm.gridApi.selection.getSelectedRows();
                    },
                    selectedEnvelopes: function () {
                        return envelopeIds;
                    },
                },
            });
            modalInstance.result.then(
                function (params) {
                    EnvelopeService.rejectEnvelope({ envelopeIds: params.envelopeIds, motif: params.motif });
                },
                function () {}
            );
        }
    }
})();
